/** Texte der SDK-Oberfläche. v1: nur Deutsch (Spec Kap. 5, `locale: 'de'`). */
export const de = {
  codeTitle: 'Support-Code',
  codeIntro: 'Nenne diesen Code deinem Support-Ansprechpartner:',
  codeLoading: 'Code wird angefordert …',
  codeValid: (rest: string) => `Gültig noch ${rest}`,
  codeExpired: 'Der Code ist abgelaufen.',
  codeNew: 'Neuen Code anfordern',
  cancel: 'Abbrechen',
  close: 'Schließen',
  errorConnect: 'Keine Verbindung zum Support-Server. Bitte versuche es später erneut.',
  errorCapacity: 'Gerade sind alle Support-Plätze belegt. Bitte versuche es später erneut.',
  errorGeneric: 'Der Support-Code konnte nicht angefordert werden.',
  errorBlocked: 'Support ist für diese Seite derzeit nicht verfügbar.',
  consentTitle: (agent: string) => `${agent} möchte deinen Bildschirm sehen`,
  consentIntro: (agent: string) =>
    `${agent} kann dir etwas zeigen, aber nichts steuern. Du kannst die Session jederzeit über „Beenden“ in der roten Statusanzeige beenden.`,
  consentShared: 'Geteilt wird:',
  consentSharedWhat: 'dieser Browser-Tab',
  consentNotShared: 'Nicht geteilt werden:',
  consentNotSharedWhat: 'andere Tabs, Passwörter, maskierte Felder',
  consentRecording: 'Die Session wird aufgezeichnet.',
  accept: 'Freigeben',
  decline: 'Ablehnen',
  statusLive: (agent: string) => `Support-Session mit ${agent} läuft`,
  statusReconnecting: 'Verbindung wird wiederhergestellt …',
  end: 'Beenden',
  statusMove: 'Zum Verschieben ziehen',
  controlTitle: (agent: string) => `${agent} möchte deinen Bildschirm steuern`,
  controlHint: 'Du kannst jederzeit durch eine eigene Eingabe abbrechen.',
  controlAccept: 'Steuerung erlauben',
  controlActive: (agent: string) => `${agent} steuert gerade`,
  controlStop: 'Steuerung beenden',
} as const;

export type Strings = typeof de;
